import Vue from 'vue'

Vue.filter('toCurrency', (value) => {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('en-UK', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
  })
  return formatter.format(value)
})
